import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AaptivRoles } from '@skyfit/core-data-library';

export interface NavLink {
  label: string;
  route: string;
  ariaLabel?: string;
  iconPath?: string;
  accessRoles?: AaptivRoles[];
  hiddenForSsoOAuth?: boolean;
}

@Component({
  selector: 'app-main-tab',
  templateUrl: './main-tab.component.html',
  styleUrl: './main-tab.component.css',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
})
export class MainTabComponent {
  @Input() link!: NavLink;
}
